import React, { useEffect, useState } from 'react';
import { useAuthStore } from '../../stores/authStore';
import { useFilterStore } from '../../stores/filterStore';
import { fetchCarteiras, Carteira } from '../../features/dashboard/services/dashboardAPI';
import CustomSelect from '../CustomSelect/CustomSelect';
import styles from './CarteiraSelector.module.css';

export const CarteiraSelector: React.FC = () => {
    const isSupervisor = useAuthStore((state) => state.role === 'supervisor' || state.role === 'diretor' || state.role === 'admin');
    const isGerente = useAuthStore((state) => state.role === 'gerente');
    const canSeeCarteiras = isSupervisor; // Gerentes não tem filtro de carteiras/vendedores, veem apenas "Toda a Regional"
    const { selectedCarteiraId, setSelectedCarteiraId } = useFilterStore();
    const [carteiras, setCarteiras] = useState<Carteira[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (canSeeCarteiras) {
            const loadCarteiras = async () => {
                try {
                    setLoading(true);
                    const response = await fetchCarteiras();
                    setCarteiras(response.data);
                } catch (err) {
                    console.error("Falha ao buscar carteiras:", err);
                } finally {
                    setLoading(false);
                }
            };
            loadCarteiras();
        }
    }, [canSeeCarteiras]);

    if (!canSeeCarteiras || loading) return null;

    const teamLabel = isGerente ? 'Toda a Regional' : 'Toda a Equipe';
    const selectorLabel = isGerente ? 'Regional' : 'Equipe';

    const options = [
        { value: '', label: teamLabel },
        ...carteiras.map(c => ({ value: c.ID, label: c.BASE }))
    ];

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedCarteiraId(e.target.value || undefined);
    };

    return (
        <div className={styles.wrapper}>
            <CustomSelect
                id="carteira-select"
                value={selectedCarteiraId || ''}
                onChange={handleChange}
                options={options}
                placeholder={teamLabel}
                className={styles.carteiraSelect}
                label={selectorLabel}
            />
        </div>
    );
};
